import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ListDirective } from '@un-fao/lightforms-lib/lightforms-components';
import { SearchRequest, SearchService, ConfigurationService } from '@un-fao/lightforms-lib/lightforms-services';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    standalone: false
})
export class HomeComponent implements OnInit 
{  
  public currentYear: number = new Date().getFullYear();
  public items: Array<any>;
  public searchRequest: SearchRequest;
  public pageReady: boolean = false;
 
  constructor(
    private searchService: SearchService,
    private activatedRoute: ActivatedRoute,
    private configurationService: ConfigurationService,
    private router: Router
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }
  
  ngOnInit() 
  {
    this.activatedRoute.queryParams.subscribe(params => {
      this.searchRequest = ListDirective.parsePageRequest(this.configurationService.env.advancedSearch,params);
      this.pageReady = true;
    });
  }
}
